import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Dialog, IconButton, Box, useMediaQuery,
} from '@material-ui/core';
import HeaderTitle from 'components/BikePage/Header/HeaderTitle';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paperWidthFalse': {
      width: '49.6%',
      // boxShadow: "none",
      padding: theme.spacing(3, 0, 0, 0),
      color: '#000',
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
  },
  scrollPaperOverride: {
    [theme.breakpoints.down('md')]: {
      alignItems: 'flex-start',
    },
  },
  dialogPaperOverride: {
    [theme.breakpoints.only('md')]: {
      margin: theme.typography.pxToRem(48),
    },
  },
  modalHeader: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(0, 2),
  },
  modalClose: {
    width: theme.spacing(6),
    height: theme.spacing(6),
  },
  closeICon: {
    fontSize: theme.typography.pxToRem(48),
  },
}));

const Modal = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const {
    onClose, open, content, data,
  } = props;
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      className={classes.root}
      fullScreen={fullScreen}
      maxWidth={false}
      onClose={() => {
        onClose();
      }}
      open={open}
      classes={{
        scrollPaper: classes.scrollPaperOverride,
        paper: classes.dialogPaperOverride,
      }}
    >
      <Box className={classes.modalBody}>
        <Box className={classes.modalHeader}>
          <HeaderTitle data={data} isModalTitle />
          <IconButton
            className={classes.modalClose}
            onClick={() => {
              onClose();
            }}
            component="span"
          >
            <CloseIcon className={classes.closeICon} />
          </IconButton>
        </Box>
        <Box>{content}</Box>
      </Box>
    </Dialog>
  );
};
export default Modal;
